import { CommitteesItem } from "./CommitteesItem";

export default CommitteesItem;